import React, { useEffect, useState } from "react";
import ButtonAHSF from "../../Components/ButtonAHSF";
import "./style.css";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useDispatch, useSelector } from "react-redux";
import { UpdateWorkFlowSteps } from "../../Redux/Reducers/WorkFlowSteps";
import { useNavigate } from "react-router-dom";
import { GetValidationTasks } from "../../Redux/Reducers/ValidationTasksManager";
import PopupAHSF from "../../Components/PopupAHSF";
import { UpdateStepsAction } from "../../Redux/Reducers/StepsAction";
import LoaderAHSF from "../../Components/LoaderAHSF";

const ButtonActionManager = (props) => {
  const dispatch = useDispatch();
  const navigat = useNavigate();
  const state = useSelector((state) => ({
    StepsAction: state.StepsAction.StepsAction,
    RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
  }));
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const [popUpList, setPopUoList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (props.list) {
      setLoading(false);
    }
  }, []);
  console.log(state.StepsAction,"sldklskdlskdlksldlksd");
  
  const TackActionOnClick = async (actionGuid) => {
    setLoading(true);
    // props.onUpdateActionButton(actionGuid);
    //[,]
    //للتعديل على بيان الاسباب main task
    await dispatch(
      UpdateStepsAction({
        wF_StepsActionGuid: state.StepsAction?.wF_StepsActionGuid,
        statementReasons: state.StepsAction?.statementReasons,
        actionType: state.StepsAction?.actionType,
        taskFlowGUID: state.StepsAction?.taskFlowGUID,
      })
    );
    const validate = await dispatch(
      GetValidationTasks({
        mainTaskGuid: props.taskGuid,
        subTasksGuid: props.subTaskGuid,
        typeTasks: props.typeTasks,
        actionGuid: actionGuid,
      })
    );
    //[,]
    //after validate end show popup validation if any
    if (validate.payload.length != 0) {
      setPopUoList(validate.payload);
      setisPopupOpenStatus(true);
      setLoading(false);
    } else {
      //[,]
      //after validate end update work flow
      const update = await dispatch(
        UpdateWorkFlowSteps({
          flowActionGUID: actionGuid,
          appGuid: localStorage.getItem("aI_ApplicationInformationId_Manager"),
          subTaskGuid: props.subTaskGuid,
          taskGuid: props.taskGuid,
        })
      );
      if (update.payload) {
        if (
          state.RoleByUserGuid.includes("fd21937f-89d0-442e-8010-5b88e360bd48")
        ) {
          navigat("/grants/manager/TasksManager/");
        } else {
          navigat("/grants/manager/SingleTaskManager/");
        }
        setLoading(false);
      }
    }
    //console.log(validate, "validateTaslsM");
  };
  //console.log(props.list,"llllllkkkkkkkkkkkk");

  return props.list ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="اخذ اجراء"
        child={[
          // [,]
          //to renden action btns by flow and task
          <div className="button-container">
            <div className="button-containerOne">
              {props.list
                ? props.list?.map((elem, index) => {
                    return (
                      <div className="button">
                        <ButtonAHSF
                          key={index}
                          //   type={"submitter"}
                          onClick={() => TackActionOnClick(elem.flowActionGUID)}
                          disabled={false}
                          title={elem.wF_FlowAction?.flowActionName}
                          text={elem.wF_FlowAction?.flowActionName}
                          show={true}
                          id={"ButtonAHSFAction"}
                        />
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>,
        ]}
      />
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        valedatManager={true}
        maxWidth="50%"
        title="تنبيه"
        componentBody={popUpList}
      />
      <LoaderAHSF show={loading} />
    </>
  ) : (
    ""
  );
};

export default ButtonActionManager;
